import { recordPage, recordEventCustomOnly } from 'utilities/uTagging';
import { SECTION_TYPE } from '../constants';

const { PERSONAL_DATA, PRECONTRACTUAL_DOCS, EMAIL_OTP_VALIDATION, ACCESS_DATA } = SECTION_TYPE;

const section = {
    [PERSONAL_DATA]: {
        event_name: 'step_personalData',
        pageName: 'onboarding/step1/personalData',
        processStep: 'step1',
        processDetail: 'personalData',
        nombrePagina: '/onboarding/abre-tu-cuenta/datos personales',
        detalleProceso: 'datos personales',
        edit: 'modifyPersonalData',
    },
    [PRECONTRACTUAL_DOCS]: {
        event_name: 'step_readAndAcceptTheDocuments',
        pageName: 'onboarding/step2/readAndAcceptTheDocuments',
        processStep: 'step2',
        processDetail: 'readAndAcceptTheDocuments',
        nombrePagina: '/onboarding/abre-tu-cuenta/lee y acepta los documentos',
        detalleProceso: 'lee y acepta los documentos',
        edit: 'reviewReadAndAcceptTheDocuments',
    },
    [EMAIL_OTP_VALIDATION]: {
        event_name: 'step_validateEmail',
        pageName: 'onboarding/step3/validateEmail',
        processStep: 'step3',
        processDetail: 'validateEmail',
        nombrePagina: '/onboarding/abre-tu-cuenta/valida tu email',
        detalleProceso: 'valida tu email',
        edit: 'modifyValidateEmail',
    },
    [ACCESS_DATA]: {
        event_name: 'step_accessKey',
        pageName: 'onboarding/step4/accessKey',
        processStep: 'step4',
        processDetail: 'accessKey',
        nombrePagina: '/onboarding/abre-tu-cuenta/datos de acceso',
        detalleProceso: 'datos de acceso',
    },
};

export const doTagCurrentSection = ({
    type,
    isCollapsed,
    promoCode,
    jointHolderInfo,
    investmentType,
    identificadorOnboarding,
    userId,
}) => {
    if (!isCollapsed) {
        recordPage(
            section[type].nombrePagina,
            undefined,
            userId,
            undefined,
            undefined,
            promoCode,
            jointHolderInfo,
            undefined,
            undefined,
            investmentType,
            {
                event_name: section[type].event_name,
                pageName: section[type].pageName,
                sectionFamily: 'banking',
                sectionCategory: 'onboarding',
                sectionName: 'userOnboarding',
                interactionType: 'funnel',
                serviceType: 'onboarding',
                processType: 'onboarding',
                processStep: section[type].processStep,
                processDetail: section[type].processDetail,
                tipoProceso: 'onboarding',
                pasoProceso: 'abre tu cuenta',
                detalleProceso: section[type].detalleProceso,
                onboardingType: investmentType,
                onboardingHolderType:
                    jointHolderInfo.typeHolder === 'primer titular' ? 'firstTitular' : 'secondTitular',
                identificadorOnboarding,
            }
        );
    }
};

export const doTagCurrentSectionButton = type => {
    recordEventCustomOnly({
        action: 'click',
        format: 'button',
        component: 'form',
        element: 'next',
        eventCategory: section[type].pageName,
        eventAction: 'clickButton',
        eventLabel: 'nextButton',
    });
};

export const doTagCurrentSectionEdit = type => {
    recordEventCustomOnly({
        action: 'click',
        format: 'link',
        component: 'form',
        element: section[type].edit,
        eventCategory: section[type].pageName,
        eventAction: 'clickLink',
        eventLabel: section[type].edit,
    });
};
